import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import apiReports, { IOfferLogPage } from 'api/reports';
import translations from 'services/translations/translations';

import OfferLogTable from './OfferLogTable';

/**
 * Who opened, calculated and saved this offer and its positions, newest first. For the
 * maker of the offer and the users with the right to read the log.
 */
const OfferHistoryModal = ({
  isAdditionalOffer,
  isOpen,
  offerId,
  toggle,
}: {
  isAdditionalOffer: boolean;
  isOpen: boolean;
  offerId: number;
  toggle: () => void;
}): JSX.Element => {
  const { t } = useTranslation([translations.offers]);
  const [history, setHistory] = useState<IOfferLogPage | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    setFailed(false);
    apiReports
      .getOfferHistory(offerId, isAdditionalOffer)
      .then(setHistory)
      .catch(() => setFailed(true));
  }, [isOpen, offerId, isAdditionalOffer]);

  const getContent = () => {
    if (failed) {
      return <p>{t(`${translations.offers}:history.Failed`)}</p>;
    }

    if (history === null) {
      return <p>{t(`${translations.offers}:history.Loading`)}</p>;
    }

    if (history.entries.length === 0) {
      return <p>{t(`${translations.offers}:history.Empty`)}</p>;
    }

    return <OfferLogTable entries={history.entries} />;
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xl">
      <ModalHeader className="modal-header" toggle={toggle}>
        {t(`${translations.offers}:history.Title`)}
      </ModalHeader>
      <ModalBody>
        <p className="offer-history-info">
          {t(`${translations.offers}:history.Info`)}
        </p>
        {getContent()}
      </ModalBody>
    </Modal>
  );
};

export default OfferHistoryModal;
